
// const API_HOST = 'http://127.0.0.1:8000';
 
const API_HOST = 'https://ytohvqjgmjrtghovhkex.fundedskill.com';
//const API_HOST = 'http://fundedskillbackend.pm';
const API_VERSION = '/api/';
const API_URL = API_HOST + API_VERSION;

export default API_URL;